import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import RightComponentOrderRequestSubstitute from "./OrderRequest/RightComponentOrderRequestSubstitute";
import OrderPaymentMainSubstitute from "./OrderPaymentMainSubstitute";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import { connect } from "react-redux";
const OrderPaymentSubstitute = (props) => {
  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <Container fluid className="vendor-orders-request">
            <Row>
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
              <div className="top-panel">
                <TopNavigationBarMobile displayLeft="logo" />
              </div>
              <div className="right-side-panel">
                <RightSideNavigation />
                <Container fluid>
                  <Row>
                    <Col md={8}>
                      <OrderPaymentMainSubstitute />
                    </Col>
                    <Col md={4}>
                      <RightComponentOrderRequestSubstitute payment={true} />
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className="bottom-panel"></div>
            </Row>
          </Container>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, null)(OrderPaymentSubstitute);
